export function isTheme(...themes) {
  if (themes.length === 0) {
    return false
  }

  return themes.includes(conf.theme_dir)
}
